/**
 * QuotesListRoute — skin-aware switcher for /opportunities.
 * Cockpit → QuotesListCockpit · Classic → original QuotesList
 */
import { useUISkin } from "@/data/UISkinContext";
import QuotesList from "./QuotesList";
import QuotesListCockpit from "./QuotesListCockpit";

export default function QuotesListRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <QuotesListCockpit />;
  return <QuotesList />;
}
